export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/postcard_design.0f896a2.svg";